import React, { useState, useEffect, useContext} from "react"
import { useNavigate, useParams } from 'react-router-dom';

import {
  Box,
  Container,
  Button,
  Hidden,
} from '@mui/material';

// Gouttieres horizontales de toutes les pages : [xs, sm, md, lg].
// Une seule source de verite, appliquee aux deux Container ci-dessous.
// NB : le prop maxWidth de MUI n'accepte que xs|sm|md|lg|xl|false. L'ancienne
// valeur "100%" etait invalide, donc ignoree : les pages retombaient sur la
// gouttiere par defaut de 24px, d'ou le "c'est trop etroit" de la review (S6).
// 81px = marge relevee sur les ecrans Figma de reference (1512px de large).
const GOUTTIERES = ["16px", "24px", "40px", "81px"]

const PageContentWrapper = ( {withoutHeader, withScanReturn, title, title2, buttonTitle, buttonIcon, buttonOnClick, buttonDisabled, onglets, children} ) => {
  const navigate = useNavigate();

  let { id } = useParams();

  return (
    <>
      <Box sx={{ borderBottom:"1px solid #E7E7E7", display: withoutHeader === true ? "none" : "block"}}>
        <Container maxWidth={false} disableGutters sx={{px:GOUTTIERES}}>
          {/* espacements releves sur l'export Figma de l'en-tete */}
          <Box sx={{paddingTop:"36px", paddingBottom:"6px", display:"flex", alignItems:"center", justifyContent:"space-between", flexShrink:0, gap:"10px"}}>
            {(withScanReturn === true && title) ? (
              <Box sx={{display:"flex"}}>
                <Box sx={{
                  fontSize:["26px", "36px", "46px"],
                  fontWeight:"700",
                  textTransform:"none", // « Bon Retour » -> « Bon retour » : ne pas majusculer chaque mot
                  wordBreak:"break-word",
                  color:"text.primary",
                  userSelect:"none",
                }}>
                  <span
                    style={{
                      cursor:"pointer",
                    }}
                    onClick={() => {
                      navigate("/app/scan/"+id)
                    }}
                  >
                    {`${title} / `}
                  </span>
                  <span style={{
                    color:"black",
                  }}>{title2 || ""}</span>
                </Box>

              </Box>
            ) : (
              <Box sx={{
                fontSize:["26px", "36px", "46px"],
                fontWeight:"700",
                textTransform:"none", // « Bon Retour » -> « Bon retour » : ne pas majusculer chaque mot
                wordBreak:"break-word",
              }}>
                {title}
              </Box>
            )}
            {buttonTitle &&
              <Box>
                <Hidden smDown>
                  {/* S3 : cotes Figma du bouton principal — 150x50, fond #0D0D0D,
                      texte 16px, icone a 16px du bord droit */}
                  <Button
                    variant="contained"
                    size={"medium"}
                    endIcon={buttonIcon ? buttonIcon : null}
                    onClick={buttonOnClick ? buttonOnClick : null}
                    disabled={buttonDisabled}
                    sx={{
                      height:"50px",
                      minWidth:"150px",
                      fontSize:"16px",
                      backgroundColor:"#0D0D0D",
                      paddingLeft:"19px",
                      paddingRight:"16px",
                      justifyContent:"space-between",
                      "&:hover" : {
                        backgroundColor:"#2F2F2F",
                      }
                    }}
                  >
                    {buttonTitle}
                  </Button>
                </Hidden>
                <Hidden smUp>
                  <Button
                    variant="contained"
                    size={"small"}
                    endIcon={buttonIcon ? buttonIcon : null}
                    onClick={buttonOnClick ? buttonOnClick : null}
                    disabled={buttonDisabled}
                  >
                    {buttonTitle}
                  </Button>
                </Hidden>
              </Box>
            }
          </Box>
          {(onglets && onglets.length > 0) &&
            <Box sx={{display:"flex", gap:2, pt:"22px"}}>
              {onglets.map((item, index) => {
                const estActif = item?.active !== false // sans etat explicite : actif (compat)
                return (
                  <Box
                    key={index}
                    sx={{
                      display:"flex",
                      alignItems:"center",
                      gap:"6px",
                      fontSize:["15px", "16px", "18px"],
                      fontWeight:700,
                      color: estActif ? "text.black" : "#565656",
                      pl : 2,
                      pr : 2,
                      pb : 1,
                      borderBottom: estActif ? "2px solid black" : "2px solid transparent",
                      cursor:"pointer",
                      userSelect:"none",
                      "&:hover" : {
                        borderBottom: estActif ? "2px solid black" : "2px solid #56565650",
                        color: estActif ? "text.black" : "#3a3a3a",
                      }
                    }}
                    onClick={item?.onClick ? item.onClick : null}
                  >
                    {item?.icon && item?.icon}
                    {item?.title}
                  </Box>
                )
              })}
            </Box>
          }
        </Container>
      </Box>
      <Box sx={{backgroundColor:"background.default", py:[3, 4, 5], flexGrow:1, display:"flex"}}>
        <Container maxWidth={false} disableGutters sx={{display:"flex", flexGrow:1, px:GOUTTIERES}}>
          {children}
        </Container>
      </Box>
    </>
  );
};

export default PageContentWrapper;
